import { useMediaQuery } from '@monofront/business/hooks';
import CheckGraphic from '@monofront/design-system/visuals/Icons/CheckGraphic';
import { IconSizes } from '@monofront/design-system/visuals/Icons/type';
import { forwardRef } from 'react';

interface ISelectButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  UNSAFE_className?: string;
}

const SelectButton = forwardRef<HTMLButtonElement, ISelectButtonProps>(
  ({ children, onClick, UNSAFE_className }, ref) => {
    const isMobile = useMediaQuery(800);

    return (
      <button
        ref={ref}
        type="button"
        onClick={onClick}
        className={`${UNSAFE_className} tw-lf-button tw-lf-button-sm tw-mt-2 tw-w-full desktop:tw-lf-button-md desktop:tw-mt-1`}
      >
        <span className="check-icon" aria-hidden>
          <CheckGraphic size={isMobile ? IconSizes.sm : IconSizes.md} />
        </span>
        {children}
      </button>
    );
  },
);

export default SelectButton;
